import React from 'react';
import { Users, Target, Award } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="about-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-4" data-testid="about-title">
            About <span className="gradient-text">AGOC 2026</span>
          </h1>
          <p className="text-lg text-slate-300">
            Organized by AGOS | Hosted by SGAO
          </p>
        </div>

        <div className="glass-card p-8 md:p-12 mb-12" data-testid="agos-info">
          <div className="flex items-center gap-3 mb-6">
            <Users className="h-8 w-8 text-[#FF6F4A]" />
            <h2 className="text-3xl font-semibold">All Gujarat Ophthalmic Society (AGOS)</h2>
          </div>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              The All Gujarat Ophthalmic Society (AGOS) is a premier organization dedicated to advancing
              the field of ophthalmology in Gujarat and across India. Established in 1965, AGOS has
              been at the forefront of promoting excellence in eye care through education, research,
              and professional development.
            </p>
            <p>
              With over 2,000 members comprising ophthalmologists, residents, and allied health
              professionals, AGOS serves as a vital platform for knowledge exchange and professional
              networking.
            </p>
          </div>
        </div>

        <div className="glass-card p-8 md:p-12 mb-12" data-testid="sgao-info">
          <div className="flex items-center gap-3 mb-6">
            <Target className="h-8 w-8 text-[#FFB6C1]" />
            <h2 className="text-3xl font-semibold">South Gujarat Academy of Ophthalmology (SGAO)</h2>
          </div>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              The South Gujarat Academy of Ophthalmology (SGAO) is a distinguished regional body
              dedicated to advancing ophthalmic care in South Gujarat. SGAO plays a crucial role
              in continuing medical education and fostering collaboration among eye care professionals
              in the region.
            </p>
            <p>
              As the host organization for AGOC 2026, SGAO brings its expertise in organizing
              world-class conferences and its deep understanding of the local medical community
              to ensure a successful and enriching experience for all attendees.
            </p>
          </div>
        </div>

        <div className="glass-card p-8 md:p-12 mb-12" data-testid="agoc-2026-info">
          <div className="flex items-center gap-3 mb-6">
            <Award className="h-8 w-8 text-[#FF6F4A]" />
            <h2 className="text-3xl font-semibold">AGOC 2026 Conference</h2>
          </div>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              AGOC 2026 marks the Annual Conference of the All Gujarat Ophthalmic Society. This
              year's conference is themed around "Vision, Innovation, Excellence" and aims to
              showcase the latest advancements in ophthalmology.
            </p>
            <p>
              The conference will feature renowned national and international speakers, hands-on
              workshops, live surgery demonstrations, and comprehensive scientific sessions covering
              all subspecialties of ophthalmology.
            </p>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-semibold mb-8 text-center">
            Organizing <span className="gradient-text">Committee</span>
          </h2>

          <div className="glass-card p-8 md:p-12 mb-8">
            <h3 className="text-2xl font-semibold mb-6 text-[#FFB6C1]">AGOS Committee</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/332n904t_1%20%281%29.jpg" alt="Dr. Vishnu Patel" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                <h4 className="text-lg font-semibold mb-1">Dr. Vishnu Patel</h4>
                <p className="text-sm text-[#FF6F4A] font-medium">President</p>
              </div>
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/o8i607nu_WhatsApp%20Image%202026-05-01%20at%2012.46.54%20AM.jpeg" alt="Dr. Jagdish Rana" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FFB6C1]/30" />
                <h4 className="text-lg font-semibold mb-1">Dr. Jagdish Rana</h4>
                <p className="text-sm text-[#FFB6C1] font-medium">Honorary Executive Secretary</p>
              </div>
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/ae3kvnqe_dr-sandeep-arora-sparsh-netralaya-and-cornea-transplant-center-shahibaug-ahmedabad-ophthalmologists-imp1az6ugd-250.webp" alt="Dr. Sandeep Arora" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                <h4 className="text-lg font-semibold mb-1">Dr. Sandeep Arora</h4>
                <p className="text-sm text-[#FF6F4A] font-medium">Chairman, Scientific Committee</p>
              </div>
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/34g9h2yr_bdb747f1-be71-49b2-9d08-a81a0be2408e.jpg" alt="Dr. Bhavik Zala" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FFB6C1]/30" />
                <h4 className="text-lg font-semibold mb-1">Dr. Bhavik Zala</h4>
                <p className="text-sm text-[#FFB6C1] font-medium">Treasurer</p>
              </div>
            </div>
          </div>
          
          <div className="glass-card p-8 md:p-12 mb-8">
            <h3 className="text-2xl font-semibold mb-6 text-[#FF6F4A]">Core Committee</h3>
            
            <div className="flex flex-col items-center">
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300 mb-6 neon-glow" data-testid="committee-chairman">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/3nd1f3fy_MSC.jpg" alt="Dr. Mahendra Chauhan" className="w-28 h-28 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                <h4 className="text-xl font-semibold mb-2">Dr. Mahendra Chauhan</h4>
                <p className="text-sm text-[#FF6F4A] font-medium">Chairman</p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">
                <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300" data-testid="committee-co-chairman">
                  <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/22gv73ga_WhatsApp%20Image%202026-06-06%20at%202.25.00%20PM.jpeg" alt="Dr. Nilesh Patel" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FFB6C1]/30" />
                  <h4 className="text-xl font-semibold mb-2">Dr. Nilesh Patel</h4>
                  <p className="text-sm text-[#FFB6C1] font-medium">Co-Chairman</p>
                </div>

                <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300" data-testid="committee-treasurer">
                  <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/a1c7ojjd_WhatsApp%20Image%202026-05-01%20at%208.17.01%20PM%20%281%29.jpeg" alt="Dr. Nitin Garg" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                  <h4 className="text-xl font-semibold mb-2">Dr. Nitin Garg</h4>
                  <p className="text-sm text-[#FF6F4A] font-medium">Treasurer</p>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card p-8 md:p-12 mb-8">
            <h3 className="text-2xl font-semibold mb-6 text-[#FFB6C1]">Organizing Secretaries</h3>
            
            <div className="flex flex-col items-center">
              <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300 mb-6 neon-glow">
                <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/d06nxulr_WhatsApp%20Image%202026-05-02%20at%207.19.03%20AM.jpeg" alt="Dr. Bharat Patel" className="w-28 h-28 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                <h4 className="text-xl font-semibold mb-2">Dr. Bharat Patel</h4>
                <p className="text-sm text-slate-300">Organising Secretary</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">
                <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                  <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/ujr6unlf_images.jpg" alt="Dr. Sanjay Savani" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FF6F4A]/30" />
                  <h4 className="text-xl font-semibold mb-2">Dr. Sanjay Savani</h4>
                  <p className="text-sm text-slate-300">Organising Secretary</p>
                </div>

                <div className="glass-card p-6 text-center hover:scale-105 transition-transform duration-300">
                  <img src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/1xt3lpdw_WhatsApp%20Image%202026-05-02%20at%209.18.56%20AM%20%281%29.jpeg" alt="Dr. Divyesh Shah" className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-3 border-[#FFB6C1]/30" />
                  <h4 className="text-xl font-semibold mb-2">Dr. Divyesh Shah</h4>
                  <p className="text-sm text-slate-300">Organising Secretary</p>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-card p-8 md:p-12">
            <h3 className="text-2xl font-semibold mb-6 text-[#FF6F4A]">Advisory Committee (Patrons)</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 text-center">
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Naushad Motivala</p>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Ashok Shroff</p>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Dhaval Raijiwala</p>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Upendra Kalaigar</p>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Suresh Sonani</p>
              </div>
              <div className="hover:scale-105 transition-transform duration-300">
                <p className="text-sm text-slate-300">Dr. Bharat Vasadiya</p>
              </div>
            </div>
          </div>
        </div>

        <div className="glass-card p-8 md:p-12" data-testid="president-message">
          <div className="flex items-center gap-3 mb-6">
            <Award className="h-8 w-8 text-[#FF6F4A]" />
            <h2 className="text-3xl font-semibold">President's Message</h2>
          </div>
          <div className="space-y-4 text-slate-300 leading-relaxed italic">
            <p>
              "Dear Colleagues, It gives me immense pleasure to welcome you all to the Annual
              Conference of the All Gujarat Ophthalmic Society - AGOC 2026. This year, we gather in the
              vibrant city of Surat with a vision to explore innovations and strive for excellence
              in ophthalmology.
            </p>
            <p>
              We are proud to partner with the South Gujarat Academy of Ophthalmology (SGAO) as our
              host organization. Together, we have curated an exceptional scientific program featuring
              distinguished faculty from across the nation.
            </p>
            <p>
              I am confident that this conference will provide a unique platform for learning,
              networking, and fostering collaborations. I look forward to your active participation
              and to making AGOC 2026 a memorable and enriching experience for all.
            </p>
            <p className="not-italic text-white font-semibold mt-6">
              - Dr. Mahendra Chauhan<br />
              <span className="text-sm text-slate-400">Chairman, AGOC 2026</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;